import gql from "graphql-tag";

export const dashboardQuery = gql`
  query dashboardQuery($brokerId: String!,$token:String!) {
    Dashboard(brokerId:$brokerId,token:$token){
      quotes,
      clients,
      unreadMessages
      dueTodos
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/dashboardQuery.js